import Vue from 'vue';



export default Vue.extend({

  name: 'ScoreButton',

  props: {
    flash: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    score(): void {
      this.$emit('onClick');
    }
  }



});
